import {
  HttpContext,
  HttpContextToken,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

export const SKIP_LOADER = new HttpContextToken(() => false);

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  if (req.headers.get('X-Ignore-Loader') === 'true') {
    return next(req.clone({ headers: req.headers.delete('X-Ignore-Loader') }));
  }
  if (req.context.get(SKIP_LOADER)) return next(req);
  loaderService.show();

  return next(req).pipe(
    catchError(error => {
      loaderService.hide();
      throw error;
    }),
    finalize(() => {
      loaderService.hide();
    })
  );
};

export const skipLoaderInterceptor: HttpInterceptorFn = (req, next) => {
  const modifiedReq = req.clone({
    context: new HttpContext().set(SKIP_LOADER, true),
  });

  return next(modifiedReq);
};
